var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5H7.80017C6.82008 5 6.32967 5 5.95532 5.19074C5.62604 5.35852 5.35852 5.62604 5.19074 5.95532C5 6.32967 5 6.82008 5 7.80017V16.2002C5 17.1803 5 17.6701 5.19074 18.0444C5.35852 18.3737 5.62604 18.6417 5.95532 18.8094C6.3293 19 6.81912 19 7.7973 19H8.5M8.5 5H16.2002C17.1803 5 17.6696 5 18.044 5.19074C18.3733 5.35852 18.6417 5.62604 18.8094 5.95532C19 6.3293 19 6.81912 19 7.7973V16.2031C19 17.1813 19 17.6704 18.8094 18.0444C18.6417 18.3737 18.3733 18.6417 18.044 18.8094C17.67 19 17.1809 19 16.2027 19H8.5M8.5 5V19M12 11.125H15.5M12 8.5H15.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.cd7099d537daf5e427247ff05f707f97.svg";
export { ForwardRef as ReactComponent };